module.exports = __webpack_public_path__ + "img/17f440e.jpg";